function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookLlight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 19,
    viewBox: "0 0 10 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "facebook-[#176]",
    opacity: 0.54,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.336 18.58V10.219H8.87439L9.28902 6.503H6.336V4.69308C6.336 3.73621 6.36045 2.787 7.69755 2.787H9.05184V0.130187C9.05184 0.09024 7.88854 0 6.71168 0C4.25384 0 2.71486 1.53953 2.71486 4.36648V6.503H-0.000976562V10.219H2.71486V18.58H6.336Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookLlight);
export default __webpack_public_path__ + "static/media/facebook-_llight.f4afc3325004d9556cf3eeff263904e9.svg";
export { ForwardRef as ReactComponent };